import { render, staticRenderFns } from "./ConnectionInfo.vue?vue&type=template&id=96ab2420&scoped=true&lang=html&"
import script from "./ConnectionInfo.vue?vue&type=script&lang=js&"
export * from "./ConnectionInfo.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionInfo.vue?vue&type=style&index=0&id=96ab2420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ab2420",
  null
  
)

component.options.__file = "ConnectionInfo.vue"
export default component.exports